import { useTheme } from "@mui/material";

export function useMediaDnDSupported() {
  const theme = useTheme();
  const query = `(min-width:${theme.breakpoints.values.sm}px)`;
  const { matches } = window.matchMedia(query);

  return matches;
}
